import { EventEmitter, Directive, Output, Input, HostListener, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class NgxScrollEventDirective {
    constructor() {
        this.onscroll = new EventEmitter();
        this.bottomOffset = 100;
        this.topOffset = 100;
    }
    // handle host scroll
    scrolled($event) {
        this.elementScrollEvent($event);
    }
    // handle window scroll
    windowScrolled($event) {
        this.windowScrollEvent($event);
    }
    windowScrollEvent($event) {
        const target = $event.target;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const isReachingTop = scrollTop < this.topOffset;
        const isReachingBottom = (target.body.offsetHeight - (window.innerHeight + scrollTop)) < this.bottomOffset;
        const emitValue = { isReachingBottom, isReachingTop, originalEvent: $event, isWindowEvent: true };
        this.onscroll.emit(emitValue);
    }
    elementScrollEvent($event) {
        const target = $event.target;
        const scrollPosition = target.scrollHeight - target.scrollTop;
        const offsetHeight = target.offsetHeight;
        const isReachingTop = target.scrollTop < this.topOffset;
        const isReachingBottom = (scrollPosition - offsetHeight) < this.bottomOffset;
        const emitValue = { isReachingBottom, isReachingTop, originalEvent: $event, isWindowEvent: false };
        this.onscroll.emit(emitValue);
    }
}
NgxScrollEventDirective.ɵfac = function NgxScrollEventDirective_Factory(t) { return new (t || NgxScrollEventDirective)(); };
NgxScrollEventDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NgxScrollEventDirective, selectors: [["", "libScrollEvent", ""]], hostBindings: function NgxScrollEventDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function NgxScrollEventDirective_scroll_HostBindingHandler($event) { return ctx.scrolled($event); })("scroll", function NgxScrollEventDirective_scroll_HostBindingHandler($event) { return ctx.windowScrolled($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { bottomOffset: "bottomOffset", topOffset: "topOffset" }, outputs: { onscroll: "onscroll" } });
NgxScrollEventDirective.ctorParameters = () => [];
NgxScrollEventDirective.propDecorators = {
    onscroll: [{ type: Output }],
    bottomOffset: [{ type: Input }],
    topOffset: [{ type: Input }],
    scrolled: [{ type: HostListener, args: ['scroll', ['$event'],] }],
    windowScrolled: [{ type: HostListener, args: ['window:scroll', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxScrollEventDirective, [{
        type: Directive,
        args: [{
                selector: '[libScrollEvent]'
            }]
    }], function () { return []; }, { onscroll: [{
            type: Output
        }], bottomOffset: [{
            type: Input
        }], topOffset: [{
            type: Input
        }], 
    // handle host scroll
    scrolled: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }], 
    // handle window scroll
    windowScrolled: [{
            type: HostListener,
            args: ['window:scroll', ['$event']]
        }] }); })();

class NgxScrollEventModule {
}
NgxScrollEventModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxScrollEventModule });
NgxScrollEventModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxScrollEventModule_Factory(t) { return new (t || NgxScrollEventModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxScrollEventModule, { declarations: [NgxScrollEventDirective], exports: [NgxScrollEventDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxScrollEventModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxScrollEventDirective],
                imports: [],
                exports: [NgxScrollEventDirective]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-scroll-event
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxScrollEventDirective, NgxScrollEventModule };

//# sourceMappingURL=ngx-scroll-event.js.map